import { CanvasElement, extractC4DeploymentModel } from './c4DeploymentModel';

const escapeHclString = (value: string): string => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const generateTimewebTerraformFromC4 = (
  elements: CanvasElement[],
  diagramName?: string,
): string => {
  const model = extractC4DeploymentModel(elements, diagramName);
  const supportedDatabases = model.databases.filter((database) => database.supportedEngine === 'postgres');
  const unsupportedDatabaseComments = model.databases
    .filter((database) => database.supportedEngine !== 'postgres')
    .map((database) => `# ${database.unsupportedReason} (${database.label})`);

  const resources = supportedDatabases.map((database) => `
resource "twc_database_cluster" "${database.terraformName}" {
  name = "${escapeHclString(database.name)}"
  type = "postgres"

  preset_id      = data.twc_database_preset.postgres.id
  is_external_ip = true
}

resource "twc_database_instance" "${database.terraformName}" {
  name = "app"

  cluster_id = twc_database_cluster.${database.terraformName}.id
}

resource "twc_database_user" "${database.terraformName}" {
  cluster_id = twc_database_cluster.${database.terraformName}.id

  login      = "app_user"
  password   = var.db_password
  privileges = ["SELECT", "INSERT", "UPDATE", "DELETE", "ALTER", "REFERENCES", "CREATE", "DROP", "INDEX"]
}`.trim()).join('\n\n');
  const body = [
    unsupportedDatabaseComments.join('\n'),
    resources || '# No supported C4 database elements found.',
  ].filter(Boolean).join('\n\n');
  const variableBlock = supportedDatabases.length ? `
variable "db_password" {
  description = "Password for generated PostgreSQL users."
  type        = string
  sensitive   = true
}
` : '';

  return `
terraform {
  required_version = ">= 0.13"

  required_providers {
    twc = {
      source = "tf.timeweb.cloud/timeweb-cloud/timeweb-cloud"
      version = ">= 1.3.0"
    }
  }
}

provider "twc" {}

${variableBlock}
data "twc_database_preset" "postgres" {
  location = "ru-1"
  type     = "postgres"
  disk     = 8 * 1024
}

${body}
`.trimStart();
};
